var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    strokeMiterlimit: 10,
    strokeWidth: 25,
    height: 1941.6,
    width: 2992.99,
    stroke: "currentColor",
    fill: "none",
    viewBox: "0 0 2992.99 1941.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 595.28003,
    cy: 607.78003,
    cx: 607.78003
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 240.94,
    cy: 1569.6801,
    cx: 658.39001
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 127.55878,
    cy: 1270.9491,
    cx: 1097.8243
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 233.85776,
    cy: 563.64343,
    cx: 1163.4518
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 411.01999,
    cy: 1518.08,
    cx: 1705.46
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 751.17999,
    cy: 1106.29,
    cx: 2229.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.b56206b4e3fbebf372e6870715253720.svg";
export { ForwardRef as ReactComponent };